import apiService from '../apiService'
export const auctionController = configService => {
  const service = apiService(configService)
  return {
    getAuctionFormat: () => {
      return service.get({
        url: `cms/buyer/auctionFormats`,
      })
    },
    getAuctionType: () => {
      return service.get({
        url: `cms/buyer/auctionTypes`,
      })
    },
    // getInternalFileById: id => {
    //   return service.get({
    //     url: `cms/auction/${id}/internal`,
    //   })
    // },
    // getExternalFileById: id => {
    //   return service.get({
    //     url: `cms/auction/${id}/external `,
    //   })
    // },
    // uploadInternalFile: params => {
    //   return service.post({
    //     url: `cms/auction/internal`,
    //     params,
    //   })
    // },
    // downloadInternal: id => {
    //   return service.downloadFile({
    //     url: `cms/auction/internal/${id}/download`,
    //   })
    // },
    // downloadItem: id => {
    //   return service.downloadFile({
    //     url: `cms/auction/buyer-item/${id}/download`,
    //   })
    // },
    // downloadExternal: id => {
    //   return service.downloadFile({
    //     url: `cms/auction/external/${id}/download`,
    //   })
    // },
    // downloadProductItem: (auction_id, currency_id) => {
    //   if (auction_id === '') {
    //     return service.downloadFile({
    //       url: `cms/auction/item/export-excel/${currency_id}/download`,
    //     })
    //   } else {
    //     return service.downloadFile({
    //       url: `cms/auction/item/export-excel/${auction_id}/${currency_id}/download`,
    //     })
    //   }
    // },
    // uploadAuctionItemFile: params => {
    //   return service.post({
    //     url: `cms/auction/buyer-item/upload`,
    //     params,
    //   })
    // },
    // uploadExternalFile: params => {
    //   return service.post({
    //     url: `cms/auction/external`,
    //     params,
    //   })
    // },
    getAuctionItemById: id => {
      return service.get({
        url: `cms/auction/${id}/item`,
      })
    },
    // getAuctionSupplierById: id => {
    //   return service.get({
    //     url: `cms/auction/${id}/supplier`,
    //   })
    // },
    getAuctionById: id => {
      return service.get({
        url: `cms/buyer/auction/${id}`,
      })
    },
    getSupplierListCompare: id => {
      return service.get({
        url: `cms/auction/${id}/supplier`,
      })
    },
    getApprovalHistory: event_id => {
      return service.get({
        url: `cms/buyer/approval-history/${event_id}`,
      })
    },
    getBuyerCompare: (id, auction_supplier) => {
      return service.get({
        url: `cms/buyer/auction/${id}/compare?auction_supplier=${auction_supplier}`,
      })
    },
    // auctionHistories: auctionID => {
    //   return service.get({
    //     url: `cms/buyer/auction/histories/${auctionID}`,
    //   })
    // },
    // postNoSelectionReason: params => {
    //   return service.post({
    //     url: `cms/buyer/auction/no_selection`,
    //     params,
    //   })
    // },
    selectionSupplier: params => {
      return service.put({
        url: `cms/buyer/auction/select-supplier`,
        params,
      })
    },
    getDummyList: auction_id => {
      return service.get({
        url: `cms/buyer/auction/${auction_id}/supplier/dummy`,
      })
    },
    getSupplierBidHistoryList: event_id => {
      return service.get({
        url: `cms/auction/auctionLogs/buyer/${event_id}`,
      })
    },
    getRankingBid: event_id => {
      return service.get({
        url: `cms/auction/auctionLogs/buyer/${event_id}/rank`,
      })
    },
    getBidHistoryOfSupplier: (event_id, user_id) => {
      return service.get({
        url: `cms/auction/auctionLogs/supplier/${event_id}/${user_id}`,
      })
    },
    getItemsBidHistoryOfSupplier: (event_id, user_id) => {
      return service.get({
        url: `cms/auction/auctionLogs/${event_id}/${user_id}`,
      })
    },
    getAuctionBiddingHistory: (auction_id, user_id) => {
      return service.get({
        url: `cms/buyer/auction/bid-history/${auction_id}/${user_id}`,
      })
    },
    getBiddingHistoryOfSupplier: auction_id => {
      return service.get({
        url: `cms/supplier/auction/bid-history/${auction_id}`,
      })
    },
    getAuctionEventCloseLog: event_no => {
      return service.downloadFile({
        url: `cms/auction/auctionLogs/buyer/${event_no}/close`,
      })
    },
    clearAllSelectionSelect: id => {
      return service.post({
        url: `cms/buyer/auction/clear-selection?auction_id=${id}`,
      })
    },
    downloadCompareToExcel: (id, saveType) => {
      return service.downloadFile({
        url: `cms/buyer/auction/${id}/compare/download?saving_type=${
          saveType ? saveType : ''
        }`,
      })
    },
  }
}
